import * as THREE from 'three';
import { LineBasicMaterial, Mesh, MeshBasicMaterial, Object3D } from 'three';
import { Moji } from './Moji';
import gsap from "gsap";
import { setInterval } from 'timers/promises';
import { MojisLine } from './MojisLine';
import { DataManager } from '../data/DataManager';
import { Params, Point3 } from '../data/Params';

export class Outline extends Object3D{

    static mat  :LineBasicMaterial;
    static geo  :THREE.BufferGeometry;

    ratio:number=1;
    //ストロークをレンダリングします


    init(line:MojisLine){
            
        if( Outline.mat==null ){
            
            //window.alert("init");

            Outline.mat = new LineBasicMaterial({color:0xffffff});
            Outline.geo = new THREE.BufferGeometry();

            let mojis = line.mojis;
            let points:number[] = [];

            for( let i=0;i<mojis.length;i++){
                
                let basePoints:Point3[] = mojis[i].basePoints;
                let moji = mojis[i];
                //console.log(basePoints);
                
                for( let k=0;k<basePoints.length-1;k++){
                    points.push( 200 * (basePoints[k].x)+moji.position.x );
                    points.push( 200 * (basePoints[k].y)+moji.position.y );
                    points.push( 200 * (basePoints[k].z)-100 );
                    points.push( 200 * (basePoints[k+1].x)+moji.position.x );
                    points.push( 200 * (basePoints[k+1].y)+moji.position.y );
                    points.push( 200 * (basePoints[k+1].z)-100 );                  
                }

            }

            Outline.geo.setAttribute(
                'position',
                new THREE.Float32BufferAttribute( points, 3 )
            );            
           
        }

        this.add( 
            new THREE.LineSegments(
                Outline.geo,
                Outline.mat
            )
        );

        /*
        const points:number[] = [];

        for ( let i = 0; i < lines.length; i++ ) {
            let line = lines[i];
            for( let j=0;j<line.mojis.length;j++){
                
                let basePoints:Point3[] = line.mojis[j].basePoints;
                let moji = line.mojis[j];
                
                for( let k=0;k<basePoints.length-1;k++){
                    points.push( 200 * (basePoints[k].x+moji.x) );
                    points.push( 200 * (basePoints[k].y+moji.y) );
                    points.push( 200 * (basePoints[k].z)-100 );
                    points.push( 200 * (basePoints[k+1].x+moji.x) );
                    points.push( 200 * (basePoints[k+1].y+moji.y) );
                    points.push( 200 * (basePoints[k+1].z)-100 );                  
                }

            }
        }
        geo.setAttribute(
            'position',
            new THREE.Float32BufferAttribute( points, 3 )
        );
        
        scene.add(new THREE.LineSegments(geo,this.mat))
        */

    }

    blink(){

        this.ratio=1;
        gsap.to(this,{
            duration:1,
            ratio:0,
            onUpdate:()=>{
                Outline.mat.color.r = this.ratio;
                Outline.mat.color.g = this.ratio;
                Outline.mat.color.b = this.ratio;
            }
        })

    }

}